import React, { useLayoutEffect } from 'react';
import { SafeAreaView, View } from 'react-native';
import useAppNavigation from '~/hooks/useAppNavigation';
import InsuranceSearchEmpty from '~/assets/svgs/InsuranceSearchEmpty.svg';
import { Footer, Text } from '~/components';

const QuoteResultEmpty = () => {
  const { navigate, setOptions } = useAppNavigation();

  useLayoutEffect(() => {
    setOptions({
      headerShown: false,
    });
  }, [setOptions]);

  return (
    <SafeAreaView className="bg-white h-[100%]">
      <View className="flex-1 h-[100%] w-[100%] mx-auto xl:pt-12 xl:pb-24 px-6">
        <View className="items-center w-[100%]">
          <Text className="text-left w-[100%] text-lg text-gray-400 my-5">
            Resultado da simulação
          </Text>
          <InsuranceSearchEmpty width={220} />
          <Text className="w-[100%] text-sm text-gray-400 mb-4 text-center">
            Não encontramos resultados para a sua busca de seguro auto no
            momento.
          </Text>
          <Text className="w-[100%] text-sm text-gray-400 my-4 text-center">
            Em breve, nossa equipe entrará em contato para entender suas
            preferências e oferecer opções personalizadas alinhadas às suas
            necessidades!
          </Text>
        </View>
      </View>
      <Footer
        className="self-center absolute bottom-0"
        buttonLabel="VOLTAR PARA A HOME"
        onSubmit={() => navigate('MarisaServicos_Home')}
      />
    </SafeAreaView>
  );
};

export default QuoteResultEmpty;
